import React from 'react'
import { FormComponent } from '../../../components/form/DynamicForm'
import { Form, Validators } from '../../../components/form/DynamicFormTs'
import { withRouter } from "react-router-dom";

class TipoCargo extends FormComponent {

  componentDidMount() {
    this.FormConfig(
      { defaultUrl: 'cargo-credito-tipo/one', saveUrl: 'cargo-credito-tipo/save', backUrl: '/Catalogo/TiposCargos' },
      new Form([
        Form.Field('text', 'cc_tipo', 'Tipo', '', [Validators.required], 6),
      ], ['Guardar'], 'Tipo'), this.formData
    )
    if (this.props.match.params.id)
      this.LoadPreds()
  }

  render() {
    return (
      <div>
        <this.FormRender />
      </div>
    )
  }
}

export default withRouter(TipoCargo)
